import React from "react";
import { Result } from "antd";
import { useNavigate } from "react-router-dom";
import { ROUTE_CONSTANTS } from "src/routes/routeConstant";
import { CustomButton } from "src/components/ui";
import { cn } from "src/util/cn";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={cn("flex items-center justify-center min-h-screen", "bg-[var(--color-gray1)]")}>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <CustomButton type="primary" onClick={() => navigate(ROUTE_CONSTANTS.HOME)}>
            Back Home
          </CustomButton>
        }
      />
    </div>
  );
};

export default NotFound;
